export default {
  namespaced: true,

  state: () => ({
    recommendations: {},
  }),

  getters: {
    getRecommendations: (state) => state.recommendations,
    getRecommendationBySlot: (state) => (slot) => {
      const data = Array.isArray(state.recommendations[slot])
        ? state.recommendations[slot]?.[0]
        : state.recommendations[slot];

      return data ?? null;
    },
  },

  mutations: {
    setRecommendations(state, value) {
      state.recommendations = {
        ...state.recommendations,
        ...value,
      };
    },
  },

  actions: {
    async fetchRecommendations({ commit }, requestBody) {
      const result = await this.$apiBFF.fetchRecommendations(requestBody);

      commit('setRecommendations', result);
    },
  },
};
